import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import { QuickNotesButton } from 'wsm-highlighted-attribute';

/**
 * Component for rendering the additional details section with highlighted attributes
 */
export const AdditionalDetails = ({
	attributes,
	quickNotesAttrs,
	prefs,
	hasAdditionalDetails
}) => {
	if (!hasAdditionalDetails || !attributes || attributes.length === 0) {
		return null;
	}

	return (
		<QuickNotesButton quickNotesAttrs={quickNotesAttrs}>
			<ul
				className={setClassNames([
					'additional-details',
					'list-inline',
					'mb-0',
					'font-weight-normal',
					'd-flex',
					'flex-wrap',
					'ml-0',
					prefs.titleDetailsSize,
					'mt-3',
					prefs.titleDetailsColor
				])}
			>
				{attributes.map((attribute, index) => (
					<li
						className="px-0"
						key={attribute.props.type || `attribute-${index}`}
					>
						{attribute}
					</li>
				))}
			</ul>
		</QuickNotesButton>
	);
};

AdditionalDetails.propTypes = {
	attributes: PropTypes.arrayOf(PropTypes.node).isRequired,
	quickNotesAttrs: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string.isRequired,
			highlightedAttr: PropTypes.node.isRequired,
			note: PropTypes.node
		})
	).isRequired,
	prefs: PropTypes.shape({
		enableLineBreak: PropTypes.string,
		titleDetailsSize: PropTypes.string,
		titleDetailsColor: PropTypes.string
	}).isRequired,
	hasAdditionalDetails: PropTypes.bool.isRequired
};
